import { FC, useCallback, useState } from 'react';
import Cropper, { Area } from 'react-easy-crop';
import { Modal } from 'src/components/UI/Modal';
import { UIButton } from 'src/components/UI/UIButton';
import { useSetModal } from 'src/providers/ModalsProvider';
import { EditImageModalSettings } from 'src/types/modal';
import { getCroppedImg } from 'src/utils/cropImage.ts';

export const EditImageModal: FC<EditImageModalSettings> = ({ onSuccess, imageSrc }) => {
  const setModal = useSetModal();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const onCropComplete = useCallback((_croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = async () => {
    if (imageSrc && croppedAreaPixels) {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      onSuccess(croppedImage);
      setModal(null);
    }
  };

  return (
    <Modal size="lg">
      <div className="modal-title">Customize the photo</div>
      <div className="relative min-h-[350px]">
        <div className="crop-container">
          {imageSrc && (
            <Cropper
              style={{
                containerStyle: {
                  borderRadius: '24px',
                },
                cropAreaStyle: {
                  borderRadius: '32px',
                },
              }}
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={4 / 3}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          )}
        </div>
      </div>

      <div className="mt-10 flex space-x-4">
        <UIButton
          buttonType="stroke"
          className="w-full text-gray-600"
          onClick={() => setModal(null)}
        >
          Cancel
        </UIButton>
        <UIButton className="w-full" onClick={handleSave}>
          Save
        </UIButton>
      </div>
    </Modal>
  );
};
